import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwVerliescompensatie,
  SpecificatieVerliescompensatie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-verliescompensatie-box1',
  templateUrl: './overzicht-verliescompensatie-box1.component.html',
  styleUrls: ['./overzicht-verliescompensatie-box1.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class OverzichtVerliescompensatieBox1Component implements OnInit {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specVerliescompensatieFormGroup = this.fb.group<AangifteRapport>({});
    specVerliescompensatie = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specVerliescompensatieFormGroup = this.fb.group<AangifteRapport>(({
            specificatieVerliescompensatie: this.fb.group<SpecificatieVerliescompensatie>(({
                opbouw: this.fb.group<OpbouwVerliescompensatie>(({
                    verrekendVerliesBox1: null as unknown as number,
                    verrekendVerliesBox2: null as unknown as number,
                } as OpbouwVerliescompensatie))
            } as SpecificatieVerliescompensatie))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specVerliescompensatieFormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specVerliescompensatieFormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specVerliescompensatie=this.partnerRapport;
            this.specVerliescompensatieFormGroup.patchValue(this.partnerRapport);
        } else {
            this.specVerliescompensatie=this.aangifteRapport;
            this.specVerliescompensatieFormGroup.patchValue(this.aangifteRapport);

        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

